module.exports = __webpack_public_path__ + "img/symbol_9.aca04014.png";